$(window).scroll(function() {
    if ($('body').hasClass('home')) {
        if ($(window).scrollTop() >= $('.site-main').offset().top - 50 && !$('.wrapper-menu').hasClass('is-sticky')){
            $('.wrapper-menu, .site-main, .social-buttons').addClass('is-sticky');
        } else if ($(window).scrollTop() <= $('.site-main').offset().top - 50 && $('.wrapper-menu').hasClass('is-sticky')) {
            $('.wrapper-menu, .site-main, .social-buttons').removeClass('is-sticky'); 
        }
    }
});